import { Box, Text, Tooltip, useMatches } from '@mantine/core';
// import {PermissionType, RoleType, useRoleBoundary} from '@feature/security'; // TODO
import { Link as RouterLink, useMatchRoute } from '@tanstack/react-router';
import { ReactNode } from 'react';
import { create } from 'zustand';

import classes from '../Sidebar.module.css';

export interface SidebarItem {
  to: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;

  // permission: PermissionType | null;
  // role?: RoleType; TODO
}

export function useSidebarItems({
  isCollapsed,
  items,
  header,
  footer,
  baseUrl,
}: {
  isCollapsed: boolean;
  header?: ReactNode;
  footer?: ReactNode;
  items: SidebarItem[];
  baseUrl: string | null;
}) {
  // const {hasPermission, isRole} = useRoleBoundary(); TODO
  const matchRoute = useMatchRoute();
  return (
    <>
      {header}
      {items
        // .filter(l => l.permission == null || hasPermission(l.permission))
        // .filter(l => l.role == null || isRole(l.role))
        .map(item => (
          <Tooltip
            label={item.label}
            disabled={!isCollapsed}
            key={item.to}
          >
            <RouterLink
              className={classes.link}
              data-active={!!matchRoute({ to: baseUrl != null ? `/${baseUrl}/${item.to}` : item.to, fuzzy: true })}
              to={item.to}
            >
              {item.icon && (
                <Box className={classes.linkIcon}>
                  <item.icon size="20px" />
                </Box>
              )}
              {!isCollapsed && (
                <Tooltip label={item.label}>
                  <Text
                    component="span"
                    size="sm"
                    lineClamp={1}
                  >
                    {item.label}
                  </Text>
                </Tooltip>
              )}
            </RouterLink>
          </Tooltip>
        ))}
      {footer}
    </>
  );
}

interface SidebarState {
  isMainActive: boolean;
  hasSidebarContext: boolean;
  setHasSidebarContext: (val: boolean) => void;
  toggleMainActive: () => void;
  setMainActive: (val: boolean) => void;
}

export const useSidebarStateStore = create<SidebarState>()(set => ({
  isMainActive: true,
  hasSidebarContext: false,
  setMainActive: (isMainActive: boolean) => set({ isMainActive }),
  setHasSidebarContext: (hasSidebarContext: boolean) => set({ hasSidebarContext }),
  toggleMainActive: () => set(prev => ({ isMainActive: !prev.isMainActive })),
}));

export function useSidebarState() {
  return useSidebarStateStore(state => state);
}

export function useContextSidebarType(): 'navbar' | 'sidebar' {
  return useMatches({
    base: 'navbar',
    sm: 'sidebar',
  });
}
